import { render, staticRenderFns } from "./QuantificationInstructions.vue?vue&type=template&id=25c891cf&"
import script from "./QuantificationInstructions.vue?vue&type=script&lang=js&"
export * from "./QuantificationInstructions.vue?vue&type=script&lang=js&"
import style0 from "./QuantificationInstructions.vue?vue&type=style&index=0&id=25c891cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports